@if (loadingService.isLoading()) {
  <div class="overlay">
    <p-progress-spinner animationDuration=".5s" fill="transparent" strokeWidth="8" [style]="{ width: '50px', height: '50px' }" />
  </div>
}
